import { addSafetyMonitoringReport, editRiskAssessment } from "./actions.js";

import ItemListView from "../../../components/ItemListView/ItemListView.vue";
import ItemView from "../../../components/ItemView/ItemView.vue";
import attachables from "./attachables.js";
import { getRiskColor } from "../Forms/actions.js";
import { tooltip as overallRiskTooltip } from "./overallRiskTooltip.js";

export default [{
    "path": "/SafetyManagement/SafetyMonitoringReports",
    "component": { ...ItemListView },
    "name": "Safety Monitoring Reports",
    "meta": {
        "app": "SafetyManagement",
        "sideNav": true,
        "appSwitcher": false,
        "sideNavSection": "Safety and Risk Management",
        "name": "Safety Monitoring Reports",
        "tableSettings": "RiskRegister",
        "dataPath": "SafetyManagement/SafetyMonitoringReports",
        "selectionRoute": "SafetyManagement/SafetyMonitoringReports/{ID}",
        "menuActions": [{
            "label": "Add Safety Monitoring Report",
            "action": addSafetyMonitoringReport
        }]
    }
}, {
    "path": "/SafetyManagement/SafetyMonitoringReports/:id",
    "component": ItemView,
    "name": "Safety Monitoring Report",
    "meta": {
        "app": "SafetyManagement",
        "name": "Safety Monitoring Report",
        "dataPath": "SafetyManagement/SafetyMonitoringReports",
        "storeData": ["Database/DocumentTypes", "SafetyManagement/Categories"],
        "title": (item) => `Safety Monitoring Report: ${item.Number}`,
        "dataFields": [{
            "label": "Number",
            "key": "Number"
        }, {
            "label": "Title",
            "key": "Title",
            "class": "md:col-span-2"
        }, {
            "label": "Likelihood",
            "key": "Likelihood"
        }, {
            "label": "Consequence",
            "key": "Consequence"
        }, {
            "label": "Overall Risk",
            "tooltip": overallRiskTooltip,
            compute({ pageItem }) {
                return getRiskColor(pageItem?.Likelihood?.split(" - ")[0], pageItem?.Consequence?.split(" - ")[0]);
            }
        }, {
            "label": "Latest Revision",
            "key": "Revision",
            "type": "text",
            "actionButton": true,
            "actionText": "Download",
            async action({ pageItem, db }) {
                let url = await db.download(`Database/SafetyMonitoringReports/${pageItem.ID}/Revisions/${pageItem.RevisionID}/${pageItem.Revisions[pageItem.RevisionID].File}`);
                window.open(url, "fileView", "popup");
            }
        }],
        "menuActions": [{
            "label": "Edit Risk Assessment",
            "action": editRiskAssessment
        }],
        "attachedItems": {
            "Details": {
                "attachables": attachables
            }
        }
    }
}];
